import {snapValueToStep as $drHW0$snapValueToStep, clamp as $drHW0$clamp} from "@react-aria/utils";
import {useControlledState as $drHW0$useControlledState} from "@react-stately/utils";
import {useState as $drHW0$useState, useRef as $drHW0$useRef} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $8f011f344c0ccbcc$exports = {};

$parcel$export($8f011f344c0ccbcc$exports, "useSliderState", () => $8f011f344c0ccbcc$export$e5fda3247f5d67f9);



const $8f011f344c0ccbcc$var$DEFAULT_MIN_VALUE = 0;
const $8f011f344c0ccbcc$var$DEFAULT_MAX_VALUE = 100;
const $8f011f344c0ccbcc$var$DEFAULT_STEP_VALUE = 1;
function $8f011f344c0ccbcc$export$e5fda3247f5d67f9(props) {
    const { isDisabled: isDisabled , minValue: minValue = $8f011f344c0ccbcc$var$DEFAULT_MIN_VALUE , maxValue: maxValue = $8f011f344c0ccbcc$var$DEFAULT_MAX_VALUE , numberFormatter: formatter , step: step = $8f011f344c0ccbcc$var$DEFAULT_STEP_VALUE  } = props;
    var _defaultValue;
    const [values, setValues] = $drHW0$useControlledState(props.value, (_defaultValue = props.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : [
        minValue
    ], props.onChange);
    const [isDraggings, setDraggings] = $drHW0$useState(new Array(values.length).fill(false));
    const isEditablesRef = $drHW0$useRef(new Array(values.length).fill(true));
    const [focusedIndex, setFocusedIndex] = $drHW0$useState(undefined);
    const valuesRef = $drHW0$useRef(null);
    valuesRef.current = values;
    const isDraggingsRef = $drHW0$useRef(null);
    isDraggingsRef.current = isDraggings;
    function getValuePercent(value) {
        return (value - minValue) / (maxValue - minValue);
    }
    function getThumbMinValue(index) {
        return index === 0 ? minValue : values[index - 1];
    }
    function getThumbMaxValue(index) {
        return index === values.length - 1 ? maxValue : values[index + 1];
    }
    function isThumbEditable(index) {
        return isEditablesRef.current[index];
    }
    function setThumbEditable(index, editable) {
        isEditablesRef.current[index] = editable;
    }
    function updateValue(index, value) {
        if (isDisabled || !isThumbEditable(index)) return;
        const thisMin = getThumbMinValue(index);
        const thisMax = getThumbMaxValue(index);
        // Round value to multiple of step, clamp value between min and max
        value = $drHW0$snapValueToStep(value, thisMin, thisMax, step);
        valuesRef.current = $8f011f344c0ccbcc$var$replaceIndex(valuesRef.current, index, value);
        setValues(valuesRef.current);
    }
    function updateDragging(index, dragging) {
        if (isDisabled || !isThumbEditable(index)) return;
        const wasDragging = isDraggingsRef.current[index];
        isDraggingsRef.current = $8f011f344c0ccbcc$var$replaceIndex(isDraggingsRef.current, index, dragging);
        setDraggings(isDraggingsRef.current);
        // Call onChangeEnd if no handles are dragging.
        if (props.onChangeEnd && wasDragging && !isDraggingsRef.current.some(Boolean)) props.onChangeEnd(valuesRef.current);
    }
    function getFormattedValue(value) {
        return formatter.format(value);
    }
    function setThumbPercent(index, percent) {
        updateValue(index, getPercentValue(percent));
    }
    function getRoundedValue(value) {
        return Math.round((value - minValue) / step) * step + minValue;
    }
    function getPercentValue(percent) {
        const val = percent * (maxValue - minValue) + minValue;
        return $drHW0$clamp(getRoundedValue(val), minValue, maxValue);
    }
    return {
        values: values,
        getThumbValue: (index)=>values[index]
        ,
        setThumbValue: updateValue,
        setThumbPercent: setThumbPercent,
        isThumbDragging: (index)=>isDraggings[index]
        ,
        setThumbDragging: updateDragging,
        focusedThumb: focusedIndex,
        setFocusedThumb: setFocusedIndex,
        getThumbPercent: (index)=>getValuePercent(values[index])
        ,
        getValuePercent: getValuePercent,
        getThumbValueLabel: (index)=>getFormattedValue(values[index])
        ,
        getFormattedValue: getFormattedValue,
        getThumbMinValue: getThumbMinValue,
        getThumbMaxValue: getThumbMaxValue,
        getPercentValue: getPercentValue,
        isThumbEditable: isThumbEditable,
        setThumbEditable: setThumbEditable,
        step: step
    };
}
function $8f011f344c0ccbcc$var$replaceIndex(array, index, value) {
    if (array[index] === value) return array;
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
}




export {$8f011f344c0ccbcc$export$e5fda3247f5d67f9 as useSliderState};
//# sourceMappingURL=module.js.map
